// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./MarkerCluster.Default.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("5622d04a", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css
// module id = 71
// module chunks = 4